// extracted by mini-css-extract-plugin
module.exports = {"g1iczp52":"g1iczp52"};